import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableAutomationHubReskin = (): boolean => useFeatureFlag(FeatureFlagDeclarations.enableAutomationHubReskin);
